<!--
cell input

2.props.label - {String} 显示名称
3.props.placeholder - {String} 占位符文描述
4.props.pd - {Boolean} 水平内边距
5.props.bb - {Boolean} 底边框
-->

<template>
  <div class="cell-input" :class="cls">
    <div class="cell-inner">
      <div class="lb" v-if="hasLabel">
        <label class="lbb">{{ label }}</label>
      </div>
      <div class="vl">
        <input
          class="ipt"
          type="text"
          :placeholder="placeholder"
          :maxlength="maxLength"
          v-bind:value="value"
          v-on:input="$emit('input', $event.target.value)"
          v-on:change="$emit('change', $event.target.value)"
        />
        <div class="bh" v-if="msg">{{ msg }}</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  created() {},
  mounted() {},
  data() {
    return {}
  },
  methods: {},
  props: {
    ph: {
      type: Boolean,
      default: false
    },
    pr: {
      type: Boolean,
      default: false
    },
    bb: {
      type: Boolean,
      default: false
    },
    required: {
      type: Boolean,
      default: false
    },
    label: {
      type: String,
      default: ''
    },
    placeholder: {
      type: String,
      default: ''
    },
    value: {
      type: String
    },
    hasLabel: {
      type: Boolean,
      default: true
    },
    msg: {
      type: String,
      default: ''
    },
    maxlength: {
      default: 999999
    }
  },
  computed: {
    cls() {
      return {
        ph: this.ph,
        pr: this.pr,
        bbn: this.bb
      }
    },
    maxLength() {
      const num = parseInt(this.maxlength, 10)
      if (isNaN(num)) {
        return 999999
      }
      return num
    }
  },
  components: {}
}
</script>

<style lang="scss" rel="stylesheet/scss" scoped>
@import '~assets/css/mixin.scss';

@mixin fs() {
  font-size: rem(26px);
}

.cell-input {
  &.ph {
    padding: 0 rem(20px);
  }
  &.pr {
    padding-right: rem(24px);
  }
  &.bbn {
    .cell-inner {
      @include border(bottom, #e8e8e8);
    }
  }

  .cell-inner {
    box-sizing: content-box;
    padding: rem(20px) 0;
    min-height: 2em;
    display: flex;
    @include fs;

    .lb {
      flex: 0 0 rem(160px);
      .lbb {
        display: block;
        padding: 0.4em 0;
        line-height: 1.2em;
        color: #262626;
      }
    }
    .vl {
      flex: 1;
      overflow: hidden;
      .ipt {
        display: block;
        width: 100%;
        border: 0;
        background: none;
        height: 2em;
        line-height: 2em;
        color: #121212;
        text-align: right;
        &::-webkit-input-placeholder {
          @include fs;
          color: #ccc;
          opacity: 1;
        }
      }
    }
    /*block-help*/
    .bh {
      font-size: rem(24px);
      line-height: 1.2em;
      color: #ff4b4b;
    }
  }
}
</style>
